/**
 * @desc 获取合同列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.PurchaseOrderAgreementRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/purchaseOrder/getAgreementList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
